/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionError } from 'state/analytics/AnalyticsActions';
import { ERROR_UPDATE_BENEFICIARIES } from "../beneficiaries/BeneficiaryActions";
import { beneficiariesEnabled } from "../../services/FeatureFlags";
import React, { Fragment } from 'react';
import { AAMBeaconButton } from 'components/shared/Beacon';
import {isEducationSavingsAccount, isTransferOnDeath} from 'services/AccountTypes';
import { replaceStringIfEducationSavings } from 'services/BeneficiaryV2';

const FailedBeneficiariesV2Logic = createLogic({
    type: [ERROR_UPDATE_BENEFICIARIES],

    process({ action }, dispatch, done) {
        const { beneficiaries } = action;
        const accountType = beneficiaries && beneficiaries[0] && beneficiaries[0].accountDescriptor && beneficiaries[0].accountDescriptor.accountTypeId;
        const isEducationSavings = isEducationSavingsAccount(accountType);
        if (beneficiariesEnabled()) {
            // dispatch user message
            const title = replaceStringIfEducationSavings('Beneficiary changes were not saved.', isEducationSavings);
            let url = 'https://www.troweprice.com/content/dam/iinvestor/Forms/IRABeneCh.pdf';
            if(isTransferOnDeath(accountType)) {
                url = 'https://www.troweprice.com/content/dam/iinvestor/Forms/todreg.pdf';
            }
            else if(isEducationSavings) {
                url = 'https://www.troweprice.com/content/dam/iinvestor/Forms/ESAShareholderServicesForm.pdf';
            }
            const message = () => {
                return (
                    <Fragment>
                        Try again or download and complete the paper form.
                        <div className='b-padding-block-start--micro--normal'>
                            <AAMBeaconButton
                                id='downloadPaperForm'
                                variant={'primary'}
                                onBeaconEventClick={() => {
                                    window.open(url, '_blank');
                                }}
                            >
                                Download Paper Form
                            </AAMBeaconButton>
                        </div>
                    </Fragment>
                );
            };
            dispatch(addToast(false, title, message));
            dispatch(analyticsActionError(action.type))
        }
        done();
    }
});

export default FailedBeneficiariesV2Logic;
